/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class SmartsExecutionAPI
 * @hideconstructor
 * @classdesc
 */
define([], () => {
	class SmartsExecutionAPI {
		// Enum for the execution targets
		static get TARGETS() {
			return {
				SUGGESTIONS: 'suggestions',
				EXECUTIONS: 'executions'
			};
		}

		/**
		 * @function SmartsExecutionAPI#execute
		 * @description Execute a smarts query
		 * @returns {Promise} resolves when the execution results are ready
		 */
		execute() {}

		/**
		 * @function SmartsExecutionAPI#getNonAnnotatableReasons
		 * 
		 * @description Provides reasons why smart annotations can't be applied on a layer. If
		 * a layer parameter isn't provided, all layers within the visualization
		 * are checked.
		 * 
 		 * @typedef {Object} NonAnnotatableReasons
 		 * @property {boolean} allLayers True indicates all layers are non-anotatable.
 		 * @property {Object[]} descriptions Objects describing reasons per layer.
		 *
		 * @param {string} layer Name of layer to provide non-annotatable reasons.
		 *
		 * @returns {NonAnnotatableReasons} Non-annotatable reasons of a visualization.
		*/
		/**
		 * @returns {Promise} 
		 */
		getNonAnnotatableReasons() {}
	}

	return SmartsExecutionAPI;
});
